// extracted by mini-css-extract-plugin
export default {"infoButton":"TalkUserListControl_infoButton__RqqLn"};